import { DndProvider } from 'react-dnd'
import { HTML5Backend } from 'react-dnd-html5-backend'
import { Box, FormControlLabel, Typography, Switch } from '@astro-ui/components'
import theme from '@astro-ui/theme'
import {
  ProductUploadImagePropsType,
  DEFAULT_PRODUCT_IMAGE_URL,
  MAX_IMAGE_UPLOAD,
  useProductUploadImage,
} from './useProductUploadImage'
import ConfirmationDeleteImage from './components/componentsConfirmationDeleteImage'
import EmptyBoxToUpload from './EmptyBoxToUpload'
import ImageItem from './ImageItem'
import { StyledBoxImage } from './style'

const ProductUploadImage = ({ errorMessage, value, onChange }: ProductUploadImagePropsType) => {
  const {
    confirmationDeleteDialogOpen,
    fileRefInput,
    totalExistedImage,
    productImageForm,
    handleDeleteImage,
    handleChangeFile,
    handleClickBoxImage,
    handleMoveImage,
    handleConfirmDeleteImage,
    handleCloseConfirmationDeleteImage,
    handleToggleUploadProductImage,
  } = useProductUploadImage({ value, errorMessage, onChange })

  return (
    <>
      <Box display="flex" flexDirection="column">
        <Box mb={20}>
          <FormControlLabel
            label={
              <Typography variant="body2" fontWeight={600} ml={10}>
                Upload Product Real
              </Typography>
            }
            control={
              <Switch
                checked={productImageForm.isUseRealProductImage}
                onClick={handleToggleUploadProductImage}
              />
            }
          />
          {!!errorMessage && typeof errorMessage === 'string' && (
            <Box mt="4px">
              <Typography variant="body3" color={theme.palette.error.main}>
                {errorMessage}
              </Typography>
            </Box>
          )}

          {!!errorMessage && Array.isArray(errorMessage) && (
            <Box mt="4px">
              {errorMessage.map((msg, i) => (
                <Typography
                  display="block"
                  key={`error-message-${i + 1}`}
                  variant="body3"
                  color={theme.palette.error.main}
                >
                  {msg}
                </Typography>
              ))}
            </Box>
          )}
        </Box>

        {!productImageForm.isUseRealProductImage ? (
          <StyledBoxImage>
            <img
              src={DEFAULT_PRODUCT_IMAGE_URL.url_medium}
              alt="Default-img-white-bg"
              style={{ width: '100%', height: '100%', objectFit: 'cover' }}
            />
          </StyledBoxImage>
        ) : (
          <>
            <DndProvider backend={HTML5Backend}>
              <Box display="flex" flexWrap="wrap" gap="10px">
                {productImageForm.images.map((image, index) => {
                  if (image.previewUrl)
                    return (
                      <ImageItem
                        key={image.key}
                        index={index}
                        imageSrc={image.previewUrl}
                        onClickBtnDelete={handleDeleteImage}
                        moveImage={handleMoveImage}
                      />
                    )
                  return (
                    <EmptyBoxToUpload
                      key={image.key}
                      index={index}
                      onClickBoxImage={handleClickBoxImage}
                    />
                  )
                })}
              </Box>
            </DndProvider>
            <input
              type="file"
              ref={fileRefInput}
              name="Upload"
              style={{ display: 'none' }}
              aria-hidden="true"
              accept="image/*"
              onChange={handleChangeFile}
            />
            <Box display="flex" justifyContent="center" marginTop="10px">
              <Typography variant="body2" color={theme.palette.primary.main}>
                Pilih Foto Produk ({totalExistedImage}/{MAX_IMAGE_UPLOAD})
              </Typography>
            </Box>
          </>
        )}
      </Box>

      {confirmationDeleteDialogOpen && (
        <ConfirmationDeleteImage
          onClickBtnConfirm={handleConfirmDeleteImage}
          onClickBtnClose={handleCloseConfirmationDeleteImage}
        />
      )}
    </>
  )
}

export default ProductUploadImage
